import { render } from "./IconSubstitutedNew.vue?vue&type=template&id=9bc42e16&ts=true"
import script from "./IconSubstitutedNew.vue?vue&type=script&lang=ts"
export * from "./IconSubstitutedNew.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__